const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Google General Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('GoogleGeneral', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/google-general/:subresource/:user', null, {
    submitCode: {params: {subresource: 'code', user: ''}, method: 'POST', isArray: false},
    getScopes: {params: {subresource: 'user-scopes', user: ''}, method: 'GET', isArray: false}
  });

}]);